


  document.addEventListener('DOMContentLoaded', function() {
    var calendarEl = document.getElementById('calendar');
  
    var calendar = new FullCalendar.Calendar(calendarEl, {
  
      googleCalendarApiKey: 'AIzaSyBOCWWA5Xgev9DgiUDhe1cFQB54J0jx0ZU',
      eventSources: [
        {
          googleCalendarId: 'c_910774776e3535091951216b17ff007a9451b4eaabb6fc64a234ebc223f3ae3f@group.calendar.google.com'//自分で作成したカレンダー
        },
        {
          googleCalendarId: 'ja.japanese#holiday@group.v.calendar.google.com',//日本の祝日カレンダー
          display: 'background',
          className: 'gcal-event'
        }
      ],
      contentHeight: 'auto',
      initialView: 'dayGridMonth',//デフォルトを月表示にする
      headerToolbar: {
        left: '',
        center: 'title',
        right: 'prev,today,next'//ボタンの並び順
      },
      buttonText: {
        today: '今月',
        month: '月'
      },
      locale: 'ja',//日本語表示設定
      dayCellContent: function (e) {
        e.dayNumberText = e.dayNumberText.replace('日', '');//日付のセルから日を削除
      },
      fixedWeekCount: false,//6週間表示をやめる

      aspectRatio: 1//カレンダーサイズのアスペクト比
    });
  
    calendar.render();

});
